module.exports = __webpack_public_path__ + "static/media/angry.b7c318ed.svg";